import React from "react";
import { UserProfileContextProvider } from "../UserProfile.context";
import UserProfileSidebarSidepanel from "./UserProfileSidebarSidepanel";
import UserProfileSidebarContent from "./UserProfileSidebarContent";
import UserProfileSidebarHeader from "./UserProfileSidebarHeader";
import UserProfileSidebarFooter from "./UserProfileSidebarFooter";
import "./UserProfileSidebar.scss";

/**
 * UserProfileSidebar main component
 * Contains left sidepanel and right content area
 * @author Bhavana
 */
const UserProfileSidebar = () => {
  return (
    <UserProfileContextProvider>
      <div className="user-profile-sidebar-container position-relative d-flex h-100 w-100" id="user-profile-sidebar">
        <div className="sidepanel-container border-left border-right bg-light">
          <UserProfileSidebarSidepanel />
        </div>
        <div className="sidebar-right-container flex-grow-1 d-flex flex-column bg-white">
          <div className="sidebar-header flex-shrink-0">
            <UserProfileSidebarHeader />
          </div>
          <div className="sidebar-content flex-grow-1 overflow-y-auto overflow-x-hidden">
            <UserProfileSidebarContent />
          </div>
          <div className="sidebar-footer flex-shrink-0">
            <UserProfileSidebarFooter />
          </div>
        </div>
      </div>
    </UserProfileContextProvider>
  );
};

export default UserProfileSidebar;
